import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import QrLogotype from "./logotypeQr";
import QrFrameItems from "./framesQr/QrFrameItems";
import GeneratorQR from "../generatorQR";
import ShapeColorWrapper from "./ShapeColorWrapper";
import QrTemplates from "./qrTemplates";
import { resetImgQrLink } from "../../../redux/slices/customizeQr";
import ActionButtons from "./actionButtons";
import { Col, Row } from "react-bootstrap";
import SettingSections from "./settingSections";
import { useState } from "react";
import styled from "styled-components";
import { preloaderToggle } from "../../../redux/slices/preloader";
import useCurrentLocation from "../../../hooks/useCurrentLocation";
import TemplateQr from "../templateQr";
import TemplateAction from "./actionButtons/TemplateAction";
import QrMode from "./qrMode";
import ArtLogotype from "./artLogotype";
import { designTypes } from "../../../constants/common";

const OFFSET_POSITION_HEADER = 70;

function QrSettings() {
  const getQrLinkSlice = useSelector((state) => state.getQrLinkSlice);
  const isOverlayModal = useSelector((state) => state.qrOverlay.isOverlayModal);
  const designType = useSelector((state) => state.customizeQr.designType);

  const [isStickyNav, setIsStickyNav] = useState(false);
  const [isBottomPage, setIsBottomPage] = useState(false);
  const dispatch = useDispatch();
  const { isTemplateParam } = useCurrentLocation();

  useEffect(() => {
    return () => {
      dispatch(resetImgQrLink());
    };
  }, []);

  useEffect(() => {
    const onScroll = () => {
      setIsStickyNav(window.pageYOffset >= 130);
      setIsBottomPage(
        window.innerHeight + window.scrollY + 10 >= document.body.offsetHeight
      );
    };

    window.addEventListener("scroll", onScroll);
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    if (getQrLinkSlice.status === "success" && getQrLinkSlice.link !== null) {
      dispatch(preloaderToggle(false));
    }
  }, [getQrLinkSlice.status, getQrLinkSlice.link]);

  return (
    <>
      {isStickyNav && designType === designTypes.base && (
        <>
          <div
            className="position-sticky left-0 border-top"
            style={{ top: "72px", zIndex: 490, height: 1 }}
          />
          <ContainerFluid className="container-fluid position-sticky left-0 top-0 bg-white">
            <div className="container px-0 px-md-3">
              <Row>
                <Col xs={12} lg={8} className="">
                  <SettingSections isBottomPage={isBottomPage} />
                </Col>
              </Row>
            </div>
          </ContainerFluid>
        </>
      )}
      <div className="container">
        <Row className="g-3 g-lg-4">
          <Col xs={12} lg={8}>
            <QrMode />
            {designType === designTypes.base && !isStickyNav && (
              <SettingSections isBottomPage={isBottomPage} />
            )}
            {designType === designTypes.base && <QrFrameItems />}
            {designType === designTypes.art && <ArtLogotype />}
            <ShapeColorWrapper />
            {designType === designTypes.base && <QrLogotype />}
            <QrTemplates />

            {isTemplateParam ? <TemplateAction /> : <ActionButtons />}
          </Col>
          <Col xs={12} lg={4}>
            {isTemplateParam ? (
              <TemplateQr top={165} />
            ) : (
              !isOverlayModal && <GeneratorQR top={165} />
            )}
          </Col>
        </Row>
      </div>
    </>
  );
}

export default QrSettings;

export const ContainerFluid = styled.div`
    padding-top: 105px;
  margin-top: ${-OFFSET_POSITION_HEADER}px;
  z-index: 400;
  background-color: white;
  box-shadow: 0px 5px 15px rgba(74, 74, 74, 0.15);
`;
